;(function () {
  angular
    .module('contrast.wizard.steps')
    .directive('csWizardSteps', [csWizardSteps])

  function csWizardSteps() {
    return {
      restrict: 'E',
      templateUrl: 'views/cs-wizard-steps.html',
      controller: 'csWizardStepsCtrl',
      controllerAs: 'csWizardStepsCtrl',
      scope: {
        total: '=',
        current: '=',
        width: '@'
      },
      link: function (scope, elem, attrs, ctrl) {
        if (scope.total && scope.current && scope.width) {
          ctrl.activate({
            total: scope.total,
            current: scope.current,
            width: scope.width,
            elem: elem
          })
        }
      }
    }
  }
})()
